import { Button, Grid, IconButton, Paper, TableBody, TableCell, Link as MuiLink, TableContainer, TableHead, TableRow, Typography, useTheme, Tooltip, Dialog, DialogTitle, DialogContent, TextField, DialogActions, CircularProgress } from "@material-ui/core";
import { TechWriterDate } from "../reportWritersAgenda/TechWriterDate";
import { generalFilter, useDefaultColumn } from "../../../../util/filter";
import React, { useState } from "react";
import { LSDBCoreTable } from "../../../common/LSDBCoreTable";
import moment from "moment";
import { ReportApproversNotes } from "./ReportApproversNotes";

import { useFilters, useGlobalFilter, useSortBy, useTable } from "react-table";
import CallSplitIcon from "@material-ui/icons/CallSplit";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import MuiTable from "@material-ui/core/Table";
import { toast } from "react-toastify";
import CloseIcon from '@material-ui/icons/Close';
import { useMoveToWriter } from "../../../common/CommonQueries";
import { useFetchContext } from "../../../common/FetchContext";
import ScreenWidth from "../../../common/ScreenWidth";
import { useReportApproverNotes } from "../../../common/CommonMutations";


export const DeliveredData = ({ data, refetch }: any) => {
    const defaultColumn = useDefaultColumn();
    const theme = useTheme();
    const widthCurrent = ScreenWidth();
    const { authAxios } = useFetchContext();
    const { mutateAsync: mutateMoveToWriter , isLoading:loadingWriter } = useMoveToWriter();



    const columns = React.useMemo(
        () => [
            {
                Header: "ID",
                accessor: "id",
                filter: generalFilter,
            },
            {
                id: "Approver",
                accessor: "approver_name",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "Report",
                accessor: "report_result_id",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>

            },
            {
                Header: "Customer",
                accessor: "customer_name",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "Project",
                accessor: "project_number",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "Report Version Number",
                accessor: "report_version_number",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "BOM Type",
                accessor: "bom",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "PM",
                accessor: "project_manager_name",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "Author",
                accessor: "author_name",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "NTP",
                accessor: "ntp_date",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? moment(value).format("DD-MM-YYYY HH-mm-ss") : "-"}</>
            },
            {
                id: "Contractual Obligated",
                accessor: "contractually_obligated_date",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? moment(value).format("DD-MM-YYYY HH-mm-ss") : "-"}</>
            },
            {
                id: "Date Entered",
                accessor: "date_entered",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? moment(value).format("DD-MM-YYYY HH-mm-ss") : "-"}</>
            },
            {
                id: "Report Type",
                accessor: "report_type",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
            },
            {
                id: "Status (PAN)",
                accessor: "status_pan",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "Date Verified (PM)",
                accessor: "date_verified",
                filter: generalFilter,

                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? moment(value).format("DD-MM-YYYY HH:mm:ss") : "N/A"}</>
            },
            {
                id: "Date Approved(Approver)",
                accessor: "date_approved",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? moment(value).format("DD-MM-YYYY HH:mm:ss") : "N/A"}</>

            },
            {
                id: "Date Delivered (PM)",
                accessor: "date_delivered",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",

                Cell: ({ value }: any) => <>{value ? moment(value).format("DD-MM-YYYY HH:mm:ss") : "N/A"}</>
            },
            {
                id: "approve",
                Header: "Reviewed",
                disableFilters: true,
                width: 250,
                minWidth: 150,
                maxWidth: 300,
                align: "center",
                Cell: ({ row }: any) => {
                    const { report_result_id, date_delivered } = row.original;

                    const [openRejectDialog, setOpenRejectDialog] = useState(false);
                    const [comment, setComment] = useState("");
                    const [loading, setLoading] = useState(false);

                    const handleCloseDialogs = () => {

                        setOpenRejectDialog(false);
                        setComment("");
                        setLoading(false);
                    };



                    const handleReject = async () => {
                        
                        try {
                            setLoading(true)
                            await mutateMoveToWriter({
                                report_result_id: report_result_id,
                                comments: comment,
                                authAxios,
                            });
                            toast.success("Report is rejected");
                            await refetch();
                            handleCloseDialogs();
                        } catch (error) {
                            console.log(error)
                            const message =
                                error?.response?.data?.error ||
                                error?.message ||
                                "Unexpected error occurred";
                            toast.error(message);
                            setLoading(false)
                        }
                        
                    };

                    return (
                        <>
                            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>


                                <Tooltip title="Reject">
                                    <IconButton
                                        size="small"
                                        style={{ backgroundColor: 'red', color: 'white', padding: "4px", width: "25px", height: "25px" }}
                                        onClick={() => setOpenRejectDialog(true)}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                </Tooltip>
                            </div>




                            <Dialog open={openRejectDialog} onClose={handleCloseDialogs}>
                                <DialogTitle>Reject Report</DialogTitle>
                                <DialogContent>
                                    <Typography style={{ marginBottom: "20px" }}>
                                        Are you sure you want to reject this report?
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        label="Comments"
                                        variant="outlined"
                                        size="small"
                                        value={comment}
                                        onChange={(e) => setComment(e.target.value)}
                                    />
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleCloseDialogs}>Cancel</Button>
                                    <Button
                                        onClick={handleReject}
                                        style={{ backgroundColor: 'red', color: 'white' }}
                                        variant="contained"
                                        disabled={loading}
                                    >
                                        {loading  ? (
                                            <CircularProgress size={24} color="inherit" />
                                        ) : (
                                            "Reject"
                                        )}
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </>
                    );
                }
            },

            {
                id: "notes",
                Header: "Notes",
                disableFilters: true,
                Cell: ({ row }: any) => {
                    const { approver_id, report_result_id, report } = row.original;

                    return <ReportApproversNotes
                        id={approver_id}
                        reportResultId={report_result_id}

                        type={1}
                        model={"report"}
                        invalidate={[
                            "my_reports",
                            ["projectNotes", row.values.id],
                            "report_Writer",
                        ]}
                        getNotes={useReportApproverNotes}

                    />;
                },
            },
        ],
        []
    );

    const { getTableProps, visibleColumns, headerGroups, rows, prepareRow } =
        useTable(
            {
                data: data,
                columns,
                defaultColumn,
                initialState: {
                    hiddenColumns: ["id"],

                },
            },
            useFilters,
            useGlobalFilter,
            useSortBy,

        );


    return (
        <TableContainer
            data-testid="tableContainer"
            style={{
                ...theme.tableContainer,
                maxHeight: "500px",
                overflowX: 'auto',
                overflowY: 'auto',
                whiteSpace: 'nowrap',
                maxWidth: `${widthCurrent}px`
            }}
            component={Paper}
        >
            <MuiTable stickyHeader {...getTableProps()} size="small">
                <TableHead>
                    {headerGroups.map((headerGroup) => (
                        <TableRow {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <TableCell
                                    style={{
                                        // ...theme.noLeftRightPadding,
                                        width: column.width,
                                        minWidth: column.minWidth,
                                        maxWidth: column.maxWidth,
                                        textAlign: 'center',

                                    }}
                                >

                                    <Grid
                                        container
                                        direction="row"
                                        alignItems="center"
                                        spacing={0}
                                    >
                                        <Grid item xs={12} {...column.getHeaderProps()}>
                                            <Grid
                                                container
                                                direction="row"
                                                alignItems="center"
                                                spacing={0}
                                            >
                                                <Typography variant="subtitle2">
                                                    {(
                                                        column.id === "notes" ||
                                                        column.id === "approve") &&
                                                        column.render("Header")}
                                                </Typography>
                                                {column.canFilter ? column.render("Filter") : null}
                                                {/* <Typography variant="subtitle2">
                                                    {column.render("Header")}
                                                </Typography>

                                                {!(column.id === "notes" || column.id === "add_tasks") && column.canFilter && column.render("Filter")} */}

                                                <Grid item xs={2}>
                                                    <IconButton
                                                        type="submit"
                                                        aria-label="search"
                                                        size="small"
                                                        {...column.getSortByToggleProps()}
                                                    >
                                                        {column.isSorted ? (
                                                            column.isSortedDesc ? (
                                                                <ArrowDropDownIcon />
                                                            ) : (
                                                                <ArrowDropUpIcon />
                                                            )
                                                        ) : (

                                                            column.id !== "notes" && column.id !== "approve" && <CallSplitIcon />
                                                        )}
                                                    </IconButton>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableHead>
                <TableBody>
                    {rows.map((row) => {
                        prepareRow(row);
                        return (
                            <>
                                <TableRow {...row.getRowProps()}>
                                    {row.cells.map((cell) => {
                                        return (
                                            <TableCell {...cell.getCellProps()}
                                                style={{
                                                    width: cell.column.width,
                                                    minWidth: cell.column.minWidth,
                                                    maxWidth: cell.column.maxWidth,
                                                    // textAlign: 'center',
                                                }}
                                            >
                                                {cell.render("Cell")}
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>


                            </>
                        );
                    })}
                </TableBody>
            </MuiTable>
        </TableContainer>
    )
}
